import React from "react";

import useAuth from "../../hooks/useAuth";
import HomeMenu from "common/HomeMenu";
import Challenges from "./Challenges";

import "./project_extension_library.scss"

export default function () {
    useAuth(['teacher']);

    return (
        <div id="teacher-dashboard">
            <div className="container">
                <div className="section">
                    <HomeMenu/>
                </div>
                <div className="section">
                    <Challenges/>
                </div>
            </div>
        </div>
    );
}